export const WARNING = 'WARNING';
export const ERROR = 'ERROR';
